<div id="page-loading" *ngIf="pageStatus==='loading'">
  <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
</div>

<ng-container *ngIf="pageStatus==='valid'">
  <p class="title">{{ 'greeting' | translate: {name: name} }}</p>
  <p>{{ 'auth' | translate }}</p>

  <div id="mail-box-wrapper" *ngIf="email">
    <label>{{ 'email' | translate }}</label>
    <div id="mail-box">
      <mat-icon>forward_to_inbox</mat-icon>
      {{ email | hideStars }}
    </div>
  </div>

  <div id="error" *ngIf="error"><mat-icon>info</mat-icon><div>{{ error_message }}</div></div>

  <button class="btn btn-primary btn-w-100" (click)="submit()" [disabled]="!email || loading || (isRecaptchaNeeded && !recaptchaToken)">
    <ng-container *ngIf="!loading">
      <span>{{ 'requestCode' | translate }}</span>
      <mat-icon>arrow_forward</mat-icon>
    </ng-container>
    <ng-container *ngIf="loading">
      <mat-progress-spinner color="white" mode="indeterminate" diameter="20"></mat-progress-spinner>
    </ng-container>
  </button>
</ng-container>

<app-signature-link-invalidated *ngIf="pageStatus==='invalidated'"></app-signature-link-invalidated>

<div id="error" *ngIf="pageStatus==='error'" role="alert" aria-live="assertive">
  <mat-icon>info</mat-icon>
  <div>
    <p class="title">{{ 'linkErrorTitle' | translate }}</p>
    <p>{{ 'linkErrorDescription' | translate }}</p>
  </div>
</div>
